module.exports = __webpack_public_path__ + "img/favicon_zjuidg.126060a5.svg";